// import $ from 'jquery';

$(() => {
	const $elements = $('.icon-large');
	if ($elements && $elements.length > 0) {

		System.import(
			/* webpackChunkName: "vendor/jquery.fittext@1.2" */
			'@vendor/jquery.fittext@1.2'
		).then(()=>{
			$('.icon-large').fitText(0.15);
		});
	}
});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/blocks/icon/index.js